import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import CartActions from '~redux/Cart/actions';

export function useRestoreCart() {
  const dispatch = useDispatch();
  const location = useLocation().search;
  const params = new URLSearchParams(location);
  const currentUser = useSelector((state) => state.auth.currentUser);
  const cartId = params.get('cart');
  const storeId = params.get('store');
  const dispatchMethod = params.get('dispatch-method');

  useEffect(() => {
    if (cartId) {
      dispatch(CartActions.restoreCart(cartId, storeId, dispatchMethod));
    }
  }, [cartId, storeId, dispatchMethod, dispatch, currentUser]);
}
